import React from 'react';
import PropTypes from 'prop-types';

import Search from '../../../../components/searchField';
import BlogPost from '../blogPost/simple';
import Pagination from '../../../../components/pagination';
import RightSide from '../rightSide';


const Blog = ({
  t,
  count,
  posts,
  isLoad,
  hasMore,
  checked,
  goToPage,
  criteria,
  lastPosts,
  chooseCat,
  categories,
  updateChecked,
  backgroundColor,
  loadMoreCategories,
  callbackToSetSearch }) => (
    <React.Fragment>
      <RightSide
        isLoad={isLoad}
        hasMore={hasMore}
        checked={checked}
        lastPosts={lastPosts}
        chooseCat={chooseCat}
        color={backgroundColor}
        categories={categories}
        updateChecked={updateChecked}
        loadMoreCategories={loadMoreCategories}
      />
      <div className="middlew">
        <div className="middleinner boxs">
          <Search callbackToSetSearch={callbackToSetSearch} placeholder={t('Search blog post')} />
          <div className="Blogs2">
            <div className="BlogsBoxouter">
              {posts.length ? posts.map(el => (
                <div key={el.id}>
                  <BlogPost
                    item={el}
                    color={backgroundColor}
                  />
                </div>))
                : <div>
                  <h2 className="search-unsuc">{t('Nothing to show')}</h2>
                </div>
                      }
            </div>
          </div>
          <Pagination
            goToPage={goToPage}
            count={count}
            pageSize={criteria.limit}
            page={criteria.page}
            backgroundColor={backgroundColor}
          />
        </div>
      </div>
    </React.Fragment>
);

Blog.propTypes = {
  t: PropTypes.func.isRequired,
  callbackToSetSearch: PropTypes.func.isRequired,
};

export default Blog;



// WEBPACK FOOTER //
// ./src/views/modules/blog/blogs/Blog.jsx